<template>
  <div id="dataSource" class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <div>
        <el-input
          size="small"
          v-model="search.keyword"
          :placeholder="$t('数据源描述')"
          @keydown.enter.native="searchList"
          clearable
          class="w-200px mr-10px"
        ></el-input>
        <el-button type="primary" @click="searchList">{{ $t('search') }}</el-button>
        <el-button :disabled="!$hasAccess('create')" type="primary" @click="add">{{
          $t('create')
        }}</el-button>
        <el-button @click="refresh">{{ $t('refresh') }}</el-button>
        <el-button :disabled="!$hasAccess('update')" @click="edit">{{ $t('edit') }}</el-button>
        <el-button :disabled="!$hasAccess('delete')" type="danger" @click="batchDelete">{{
          $t('delete')
        }}</el-button>
      </div>
      <div class="mt-20px" style="height: calc(100% - 106px)">
        <el-table
          v-loading="loading.init"
          :data="tableData"
          border
          stripe
          height="100%"
          @selection-change="tableSelect"
        >
          <el-table-column type="selection" width="60" align="center"></el-table-column>
          <el-table-column
            type="index"
            :label="$t('seqNo')"
            width="60"
            align="center"
          ></el-table-column>
          <el-table-column prop="type" :label="$t('数据源类型')">
            <template slot-scope="scope">
              <span>{{ _.get(_.find(typeData, { value: scope.row.type }), 'label') }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="code"
            :label="$t('数据源编码')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="name"
            :label="$t('数据源名称')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="description"
            :label="$t('数据源描述')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="createdTime"
            :label="$t('createTime')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="createdUser"
            :label="$t('创建人')"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <div class="float-right mt-20px">
        <el-pagination
          background
          @size-change="getList"
          @current-change="searchList"
          :current-page.sync="pageNo"
          :page-sizes="$pageSizeAll"
          :page-size.sync="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="small-dialog"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      v-dialogDrag
    >
      <el-form
        :model="sourceForm"
        :rules="sourceRules"
        label-width="150px"
        ref="sourceForm"
        size="small"
      >
        <el-form-item :label="$t('数据源类型')" prop="type">
          <el-select
            :disabled="changeType === 'edit'"
            v-model="sourceForm.type"
            clearable
            filterable
            class="w-full"
            @change="selectChange"
          >
            <el-option
              v-for="item in typeData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('数据源编码')" prop="code">
          <el-input
            v-model="sourceForm.code"
            clearable
            :disabled="changeType === 'edit'"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('数据源名称')" prop="name">
          <el-input v-model="sourceForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('数据源描述')" prop="description">
          <el-input v-model="sourceForm.description" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$t('数据源模型')" prop="standardId">
          <el-select v-model="sourceForm.standardId" clearable filterable class="w-full">
            <el-option
              v-for="item in standardList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="sourceForm.type === 1"
          :label="$t('外部数据源')"
          :prop="sourceForm.type === 0 ? '' : 'externalDatabaseType'"
        >
          <el-select
            v-model="sourceForm.externalDatabaseType"
            clearable
            filterable
            :disabled="sourceForm.type === 0"
            @change="getCode"
            class="w-full"
          >
            <el-option
              v-for="item in externalSourceData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="sourceForm.type === 1"
          :label="$t('外部数据源连接')"
          :prop="sourceForm.type === 0 ? '' : 'connectionString'"
        >
          <el-row class="w-440px">
            <el-col :span="20">
              <el-input
                class="!w-full"
                v-model="sourceForm.connectionString"
                clearable
                :disabled="sourceForm.type === 0"
                type="textarea"
              ></el-input>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="testConnect" :loading="loading.test">{{
                $t('测试连接')
              }}</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div class="tc" slot="footer">
        <el-button type="primary" @click="save" :loading="loading.save" size="small">{{
          $t('save')
        }}</el-button>
        <el-button @click="beforeClose" size="small">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/babel">
import StandardManagementService from '@/services/common/StandardManagementService'
import DataSourceService from '@/services/DataSourceService'

export default {
  components: {},
  data() {
    return {
      loading: {
        init: false,
        test: false,
        save: false,
      },
      search: {
        keyword: '',
      },
      tableData: [],
      pageNo: 1,
      pageSize: 15,
      total: 0,
      dialogTitle: '',
      dialogVisible: false,
      sourceForm: {
        name: '',
        code: '',
        type: '',
        description: '',
        standardId: '',
        externalDatabaseType: 0,
        connectionString: '',
      },
      sourceFormCopy: null,
      sourceRules: {
        name: [{ required: true, trigger: 'blur', message: '请输入数据源名称' }],
        code: [{ required: true, trigger: 'blur', message: '请输入数据源编码' }],
        type: [{ required: true, trigger: 'blur', message: '请选择数据源类型' }],
        externalDatabaseType: [{ required: true, trigger: 'blur', message: '请选择外部数据源' }],
        connectionString: [{ required: true, trigger: 'blur', message: '请输入外部数据源连接' }],
        standardId: [{ required: true, trigger: 'blur', message: '请选择数据源模型' }],
      },
      typeData: [
        {
          label: '内部数据源',
          value: 0,
        },
        {
          label: '外部数据源',
          value: 1,
        },
      ],
      externalSourceData: [
        {
          label: 'mysql',
          value: 0,
        },
        {
          label: 'oracle',
          value: 1,
        },
        {
          label: 'sql server',
          value: 2,
        },
      ],
      standardList: [], // 数据源模型列表
      selectionRows: [],
      changeType: '',
    }
  },
  computed: {
    currentDisplayName() {
      return _.get(this.$store.getters.pageTagsCurrent, 'displayName')
    },
    isChange() {
      return !_.isEqual(this.sourceForm, this.sourceFormCopy)
    },
  },
  watch: {},
  methods: {
    // 测试连接
    async testConnect() {
      if (!_.isFinite(this.sourceForm.externalDatabaseType)) {
        this.$message.warning('请选择外部数据源')
        return
      }
      if (!this.sourceForm.connectionString) {
        this.$message.warning('请输入外部数据源连接')
        return
      }
      this.loading.test = true
      const res = await DataSourceService.testConnect({
        databaseType: this.sourceForm.externalDatabaseType,
        connectionString: this.sourceForm.connectionString,
      })
      if (res && res.code === 0) {
        if (res.data) {
          this.$message.success('连接成功')
        } else {
          this.$message.warning('连接失败')
        }
      }
      this.loading.test = false
    },

    // 批量删除
    batchDelete() {
      if (this.selectionRows.length === 0) {
        this.$message.warning('请勾选数据!')
        return
      }
      this.$confirm('此操作将永久删除勾选数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const ids = _.map(this.selectionRows, 'id')
          const res = await DataSourceService.remove(ids)
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.getList()
          }
        })
        .catch(() => {})
    },

    // 编辑
    edit() {
      this.changeType = 'edit'
      if (this.selectionRows.length !== 1) {
        this.$message.warning('请勾选1条数据进行编辑')
        return
      }
      this.sourceForm = _.cloneDeep(this.selectionRows[0])
      this.sourceFormCopy = _.cloneDeep(this.sourceForm)
      this.dialogTitle = '编辑质检源'
      this.dialogVisible = true
      this.getStandardList()
    },

    // 新增
    add() {
      this.changeType = 'add'
      this.dialogTitle = '新增质检源'
      this.dialogVisible = true
      this.sourceForm = this.$options.data().sourceForm
      this.sourceFormCopy = _.cloneDeep(this.sourceForm)
      this.getStandardList()
    },

    // 获取编码
    async getCode() {
      this.sourceForm.code = ''
      if (!_.isFinite(this.sourceForm.type)) {
        return
      }
      if (this.sourceForm.type === 1 && !_.isFinite(this.sourceForm.externalDatabaseType)) {
        return
      }
      const res = await DataSourceService.getCode({
        databaseType: this.sourceForm.type === 1 ? this.sourceForm.externalDatabaseType : 0,
        type: this.sourceForm.type,
      })
      if (res && res.code === 0) {
        this.sourceForm.code = res.data
      }
    },

    // 保存校验
    save() {
      this.$refs.sourceForm.validate((valid) => {
        if (valid) {
          this.saveData()
        }
      })
    },

    // 保存数据
    async saveData() {
      this.loading.save = true
      let res
      const params = {
        model: this.sourceForm,
      }
      if (this.sourceForm.id) {
        res = await DataSourceService.update(params)
      } else {
        res = await DataSourceService.add(params)
      }
      if (res && res.code === 0) {
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.getList()
      }
      this.loading.save = false
    },

    // 勾选表格事件
    tableSelect(selection) {
      this.selectionRows = selection
    },

    // 数据源改变事件
    selectChange(val) {
      if (this.dialogVisible) {
        this.$refs.sourceForm.clearValidate()
      }
      if (val === 0) {
        this.sourceForm.externalDatabaseType = 0
        this.sourceForm.connectionString = ''
      }
      this.getCode()
    },

    // 页面关闭前校验
    beforeClose() {
      if (this.isChange) {
        this.$confirm(this.$t('您尚有未保存的数据是否取消'), this.$t('提示'), {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning',
        })
          .then(() => {
            this.closeAndReset()
          })
          .catch(() => {})
      } else {
        this.closeAndReset()
      }
    },

    // 关闭页面并重置表单
    closeAndReset() {
      this.dialogVisible = false
      this.$refs.sourceForm.resetFields()
    },

    // 获取数据源模型列表
    async getStandardList() {
      const res = await StandardManagementService.getList()
      if (res && res.code === 0) {
        this.standardList = res.data
      }
    },

    // 刷新
    refresh() {
      this.search = this.$options.data().search
      this.searchList()
    },

    // 搜索
    searchList() {
      this.pageNo = 1
      this.getList()
    },

    // 查询表格数据
    async getList() {
      this.loading.init = true
      const res = await DataSourceService.list({
        pageno: this.pageNo,
        pagesize: this.pageSize,
        keyword: this.search.keyword,
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.total = res.page ? res.page.recordCount : 0
      }
      this.loading.init = false
    },
  },
  async created() {
    this.getList()
  },
  mounted() {},
}
</script>

<style scoped lang="scss">

</style>
